// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__2ZQjL","dense":"_type_dense__3BY3z"};